import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalDialog,
  Typography,
  FormControl,
  FormLabel,
  Input,
  Select,
  Option,
  Button,
  Box,
  Textarea,
} from '@mui/joy';
import { toast } from 'react-toastify';
import { authFetch } from '../utils/authFetch';

export default function ModaleIssue({ open, onClose, onSuccess }) {
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [vehicleId, setVehicleId] = useState('');
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectedOrg = localStorage.getItem('selectedOrg');

  useEffect(() => {
    if (!open || !selectedOrg) return;

    const loadVehicles = async () => {
      try {
        const res = await authFetch(
          `${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/vehicle/all`,
          { credentials: 'include' }
        );

        if (!res.ok) throw new Error('Errore fetch mezzi');

        const data = await res.json();
        setVehicles(Array.isArray(data) ? data.filter((v) => v.status !== 2) : []);
      } catch (err) {
        console.error(err);
        toast.error('Impossibile caricare i mezzi');
        setVehicles([]);
      }
    };

    loadVehicles();
  }, [open, selectedOrg]);

  const reset = () => {
    setSubject('');
    setDescription('');
    setVehicleId('');
    setVehicles([]);
    setLoading(false);
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSubmit = async () => {
    if (!subject.trim() || !vehicleId) {
      toast.error('Compila tutti i campi obbligatori');
      return;
    }

    setLoading(true);

    try {
      const response = await authFetch(
        `${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/issue`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            vehicle_id: Number(vehicleId),
            subject: subject.trim(),
            description: description.trim() || null,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || 'Errore nella creazione del problema');
      }

      onSuccess?.();
      handleClose();
    } catch (err) {
      console.error('Errore creazione problema', err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalDialog sx={{ minWidth: { xs: '90%', sm: 500 } }}>
        <Typography level="h4" mb={2}>
          Nuovo Problema
        </Typography>

        <FormControl required>
          <FormLabel>Mezzo</FormLabel>
          <Select
            placeholder="Seleziona mezzo"
            value={vehicleId}
            onChange={(e, value) => setVehicleId(value)}
            disabled={loading || vehicles.length === 0}
          >
            {vehicles.map((vehicle) => (
              <Option key={vehicle.id} value={vehicle.id}>
                {vehicle.name_vehicle} {vehicle.code_vehicle ? `(${vehicle.code_vehicle})` : ''}
              </Option>
            ))}
          </Select>
        </FormControl>

        <FormControl required sx={{ mt: 2 }}>
          <FormLabel>Oggetto</FormLabel>
          <Input
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="Inserisci oggetto del problema"
            disabled={loading}
          />
        </FormControl>

        <FormControl sx={{ mt: 2 }}>
          <FormLabel>Descrizione</FormLabel>
          <Textarea
            minRows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Descrivi il problema"
            disabled={loading}
          />
        </FormControl>

        <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
          <Button variant="soft" onClick={handleClose} disabled={loading}>
            Annulla
          </Button>
          <Button
            onClick={handleSubmit}
            loading={loading}
            disabled={!subject.trim() || !vehicleId}
          >
            Crea
          </Button>
        </Box>
      </ModalDialog>
    </Modal>
  );
}